import Vue from 'vue'
import {
    Carousel,
    CarouselItem,
    Loading,
    Message,
    MessageBox,
    Upload,
    Input,
    Button,
    Progress,
    Pagination,
    Select,
    Option,
    Form,
    FormItem,
    Table,
    TableColumn,
    RadioGroup,
    Radio,
    Popconfirm,
    Popover,
    CheckboxGroup,
    Checkbox,
    DatePicker,
    Dialog,
    Breadcrumb,
    BreadcrumbItem,
    Dropdown,
    DropdownMenu,
    DropdownItem
} from 'element-ui'
import '../assets/css/element-variables.scss'

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading.directive)
Vue.use(Upload)
Vue.use(Input)
Vue.use(Button)
Vue.use(Progress)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
